import { ComponentType, useMemo } from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";

interface PrivatePageProps {
  component: ComponentType;
  [key: string]: unknown;
}

export const PrivatePage = ({ component, ...args }: PrivatePageProps) => {
  const Component = useMemo(() => withAuthenticationRequired(component), [component]);
  return <Component {...args} />;
};
